import styled from 'styled-components';

import { createTranslatedText } from '@dreryk/react-common';
import {
   IconFillColor,
   IconSize,
   IconWrapper,
   QuestionmarkCircleIcon,
   StyledFlex,
   Tooltip,
} from '@dreryk/react-components';

const StyledReasonIconWrapper = styled.span`
   fill: ${(props) => props.theme.primary};
`;
StyledReasonIconWrapper.displayName = 'StyledReasonIconWrapper';

type DocumentVersionCellProps = {
   readonly version: number;
   readonly changeReason?: string;
};

export const DocumentVersionCell = (props: DocumentVersionCellProps): JSX.Element => {
   return (
      <StyledFlex gap={'6px'}>
         {props.version}
         {props.changeReason ? (
            <Tooltip testId={'changeReason'} content={createTranslatedText(props.changeReason)}>
               <StyledReasonIconWrapper>
                  <IconWrapper testId={'changeReason'} size={IconSize.SMALLEST} fillColor={IconFillColor.INHERIT}>
                     <QuestionmarkCircleIcon />
                  </IconWrapper>
               </StyledReasonIconWrapper>
            </Tooltip>
         ) : null}
      </StyledFlex>
   );
};
